import { CanDeactivateFn } from '@angular/router';

/** Both registry editors protect dirty changes before leaving or selecting another record. */
export const registryDetailNavigationGuard: CanDeactivateFn<{
  canLeave(): boolean | Promise<boolean>;
}> = (component) => component.canLeave();
